const ACCOUNT_STORAGE_KEY = "studio:account_id";

let accountId: string | null = null;

function readStoredAccountId(): string | null {
  try {
    const fromSession = sessionStorage.getItem(ACCOUNT_STORAGE_KEY);
    if (fromSession?.startsWith("acct_")) {
      return fromSession;
    }
  } catch {
    /* private mode */
  }
  try {
    const fromLocal = localStorage.getItem(ACCOUNT_STORAGE_KEY);
    if (fromLocal?.startsWith("acct_")) {
      return fromLocal;
    }
  } catch {
    /* private mode */
  }
  return null;
}

function writeStoredAccountId(id: string | null): void {
  try {
    if (id?.startsWith("acct_")) {
      sessionStorage.setItem(ACCOUNT_STORAGE_KEY, id);
      localStorage.setItem(ACCOUNT_STORAGE_KEY, id);
      return;
    }
    sessionStorage.removeItem(ACCOUNT_STORAGE_KEY);
    localStorage.removeItem(ACCOUNT_STORAGE_KEY);
  } catch {
    /* private mode */
  }
}

export function getAccountId(): string | null {
  return accountId;
}

export function setAccountId(id: string | null): void {
  accountId = id?.startsWith("acct_") ? id : null;
  writeStoredAccountId(accountId);
}

/** Rehydrate after a full navigation away to Stripe Checkout / Portal and back. */
export function restoreAccountId(): string | null {
  if (accountId?.startsWith("acct_")) {
    return accountId;
  }
  const stored = readStoredAccountId();
  accountId = stored;
  return accountId;
}

/**
 * Stripe Checkout / Portal return URLs carry `acct=` because the session cookie
 * often does not come back after a cross-site hop to checkout.stripe.com.
 */
export function applyAccountIdFromSearch(search: string): string | null {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const acct = new URLSearchParams(raw).get("acct");
  if (!acct?.startsWith("acct_")) {
    return null;
  }
  setAccountId(acct);
  return acct;
}

export function requireAccountId(): string {
  const id = getAccountId() ?? restoreAccountId();
  if (!id?.startsWith("acct_")) {
    throw new Error(
      "No Stripe account: open Web App from the Stripe Dashboard.",
    );
  }
  return id;
}
